import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, animate, transition, style } from '@angular/animations';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ClientService } from '../create-client/client.service';
import { AdvisorBarService } from '../shared/advisor-bar/advisor-bar.service';
import { ModalComponent } from '../shared/modal/modal.component';
import { LoadingService } from '../shared/loading/loading.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Advisor } from '../models/advisor';
import { Client } from '../models/client';
import { Organization } from '../models/organization';

import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
import {FormBuilder, FormGroup, FormControl, Validators, ValidatorFn} from '@angular/forms';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PagerService } from '../services/pager.service';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';

@Component({
  selector: 'app-new-client',
  templateUrl: './new-add-client.component.html',
  styleUrls: ['./new-add-client.component.css']
})

/* const youngerThanValidator = (maxAge: number): ValidatorFn => control =>
(new Date()).getFullYear() - (new Date(control.value)).getFullYear() > maxAge 
  ? { younger: { maxAge } } 
  : null; */

export class NewAddClientComponent implements OnInit {

  public tempHCData: any;
  public error: string;
  public partnerActive: boolean = false;
  //public client: any;


public clients: any[];
public filteredClients: any[];
public selectedClient: any = {};
public reports: any[] = [];
public modalSubscription;
public loadingSubscription;
public previousUrl: string;
public pager: any = {};
public pagedItems: any[];
maxMarriedDate: Date;
minMarriedDate: Date;

isLegalSpouseTurnedOn: boolean = false;

  private navCards = [
    { title: 'Healthcare', subtitle: 'Create a new Healthcare Illustration.', icon: 'fa-ambulance', color: '#D9E8F4', iconColor: '#3385C5', image:'../../../assets/icons/healthcare_illustration.svg' },
    { title: 'Social Security', subtitle: 'Create a new Social Security Illustration.', icon: 'fa-university', color: '#EBE6FA', iconColor: '#9578E3', image:'../../../assets/icons/healthcare_illustration.svg' },
    { title: 'Medicare Means Testing', subtitle: 'Create a new Medicare Means Testing Illustration.', icon: 'fa-dollar', color: '#D6F3F2', iconColor: '#2CBFBB', image:'../../../assets/icons/healthcare_illustration.svg' },
    { title: 'Long-Term Care', subtitle: 'Create a new Long-Term Care Illustration.', icon: 'fa-user-md', color: '#fedede', iconColor: '#fe4e4e', image:'../../../assets/icons/long_term_care_illustration.svg' },
    { title: 'Combination', subtitle: 'Create a new illustration that combines Healthcare and Long-Term Care.', icon: 'fa-user-md', color: '#fedede', iconColor: '#fe4e4e', image:'../../../assets/icons/combination_illustration.svg' }
]
public dateofBirth;
public currentYear;
public yob;
public endYear1;
public endYear2;
public endOfPIAStartYear;
public endOfPIAEndYear;
public age;
public showAge;
public min;
public maxAge;
public minAge;

public spouseDateofBirth;			
public spouseYob;
public spouseEndOfPIAStartYear;
public spouseEndYear1;
public spouseEndYear2;
public spouseEndOfPIAEndYear;
public spouseShowAge;
public spouseMinAge;
public spouseMaxAge;
public SpouseMin;

public ageEighteen;
public eighteenYearsAgo;
private today = new Date();

isLinear = false;
firstFormGroup: FormGroup;
secondFormGroup: FormGroup;

lifeExpectancy: number;
spouseLifeExpectancy: number;

isValidLifeExpectancy: boolean = true;
isSpouseValidLifeExpectancy: boolean = true;
clientAge: number;
spouseAge: number;

@ViewChild('container') container: ElementRef;
@ViewChild('scrollEl') scrollEl: ElementRef;
@ViewChild('modal') modal: any;//CreateClientComponent
private selDate: IMyDate = { year: 0, month: 0, day: 0 };
public myDatePickerOptions: IMyDpOptions = {
  // other options...
  dateFormat: "mm/dd/yyyy",
  editableDateField: true,
  showTodayBtn: false,
  disableUntil: { year: 1930, month: 1, day: 1 },
  disableSince: {year: this.today.getFullYear() - 18, month: this.today.getMonth() + 1 , day: this.today.getDate() + 1}   

};

public myDatePickerOptionsAnn: IMyDpOptions = {
  // other options...
  dateFormat: "mm/dd/yyyy",
  editableDateField: true,
  showTodayBtn: false,
  disableUntil: { year: 1940, month: 1, day: 1 },
  disableSince: { year: 2020, month: 1, day: 1 }
};

// Initialized to specific date (09.10.2018).
public defaultDateModel: any = { date: { year: 1960, month: 1, day: 1 } };

public currentAddEditClientScreen: Number = 0;
public previousAddEditClientScreen: Number = 0;

public selectedDocFilePath: string;
public selectedDocEvent: any;
public selectedDocCategory: string;


public selectedDocument: any = {
  title: '',
  description: '',
  category: '',
}

public healthInformationInfo: string = "These inputs will impact life expectancy projections (see below), which is featured within every illustration and report, as well as annual out-of-pocket healthcare costs.";

public validFormInputs: any = [
  { isValid: false },
  { isValid: false },
  { isValid: false },
  { isValid: false },
  { isValid: false },
  { isValid: false },
  { isValid: false },
  { isValid: false },
];

public clientModal: any = {
  generalInformation: {
    generalInformation: {
      firstName: '',
      lastName: '',
      gender: '',
      dob: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
    },
    anticipatedRetirementInformation: {
      retirementAge: '',
      retirementState: '',
    },
  },
  financialInformation: {
    PIAYears: {
      IncludePIA: false,
      StartYear: '',
      EndYear: '',
      Years: []
    },
    hasPension: false,
  },
  maritalStatus: {
    firstName: '',
    lastName: '',
  },
  healthConditions: {},
  currentMaritalStatus: {},
  maritalHistory: {
    previouslyMarried: {},

  },
  spouses: [
    { firstName: '', lastName: '' }
  ],
  dependentChildren: {},
}

validateDefaultDate: boolean;
validateDefaultDate2: boolean; 
dissabledConinueBtn: boolean = false;


public allStates: any[] = Utils.allStates;
public allStates2: any[] = Utils.allStates;

public months: any[] = Utils.months;

public categories: any = {};

public modalName: string;
private ID: number; // ID of whatever entity we need to get data for

public advisorOrganization: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected organization.";
public assignAdvisor: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected advisor.";
public currentAgeMessage: string = "Your date of birth allows us to project inflation and other factors that will occur over time, leading up to your retirement.";
public retirementAgeMessage: string = "The age at which the client stops full-time work to fully retire or decrease work. This might not be the same as their Social Security Full Retirement Age (FRA) or Social Security claim age.";
public currentIncomeMessage: string = "This amount will be inflated out to retirement age and then multiplied by the income replacement ratio to determine projected retirement income. This should include income off of which the client currently maintains their standard of living, like compensation, bonuses, investment income, or rental income, for example.";
public maritalStatusMessage: string = "This affects your Social Security claiming options, and for those currently married, all reports with run for both you and your spouse.";
public retirementStateMessage: string = "The state in which the client plans to reside during the majority of their retirement.";
public currentIRRMessage: string = "This is the percentage of pre-retirement income that the entire household (spouse included, if applicable) will need in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
public nationalAvgMessage: string = "This should be used if the client is not sure where they might retire, even if a retirement state is selected.";

public highBloodPressureMessage: string = 'Hypertension (high blood pressure, HiBP) is an elevation of either or both the systolic and diastolic blood pressure. Hypertension is defined as systolic BP >139 mmHg and/or diastolic BP >89 mmHg.';
public highCholesterolMessage: string = "Cholesterol levels are considered elevated when greater than 200 milligrams/dL and LDL levels greater than 100 mg/dL.";
public type2DiabetesMessage: string = "A chronic disease in which carbohydrate (sugar) metabolism is impaired due to an absolute or relative insufficiency of insulin. Type 2 is non-autoimmune and is due to peripheral insulin resistance.";
public cardiovascularDiseaseMessage: string = "Diseases of the heart, arteries or veins. Common cardiovascular diseases include arteriosclerosis, coronary artery disease, heart valve disease, arrhythmias, heart failure, myocarditis, myocardiopathy, congenital heart disease, and pulmonary emboli.";
public tobaccoMessage: string = "Use of pipes, cigars, snuff, smokeless tobacco or cigarettes.";
public cancerMessage: string = "Two characteristic features define a cancer. The first is cells are abnormal (malignant) and their growth is not regulated as are normal cells. The second is the capacity of the cells to invade tissues and metastasize to both local and distant sites.";
public multipleSclerosisMessage: string = "Immune-mediated inflammatory disease of the central nervous system characterized by inflammation of the myelin sheath surrounding the axons (nerve fibers) of the brain and spinal cord.";
public type1DiabetesMessage: string = "A chronic disease in which carbohydrate (sugar) metabolism is impaired due to an absolute or relative insufficiency of insulin. Type 1 is autoimmune (Beta cells destroyed) and occurs at younger ages.";
public familyHistoryMessage: string = "An individual’s direct ancestors (e.g., parents, grandparents, aunts, uncles) have been diagnosed with Diabetes or Cardiovascular Disease.";
public dependentCaneWalkerMessage: string = "An individual is reliant on a cane, walker, or wheelchair for mobility.";

public obesityMessage: string = "Abnormal or excessive fat accumulation that presents a risk to health. A body mass index (BMI) over 30 is considered obese.";
public alzheimersMessage: string = "A brain disorder that slowly destroys memory and thinking skills and, eventually, the ability to carry out the simplest tasks.";
public amputationMessage: string = "The removal by surgery of a limb (arm or leg) or other body part because of injury or disease, such as diabetes or cancer.";
public parkinsonsMessage: string = "A brain disorder that causes unintended or uncontrollable movements, such as shaking, stiffness, and difficulty with balance and coordination.";
public ptsdMessage: string = "A prevalent and complex psychiatric condition that arises in response to exposure to traumatic events, significantly impacting an individual's mental well-being.";

public isLegalSpouse: string = "Some illustrations may be run with two non-married partners, but others may not, due to federal policies that affect projections based on marital status.";


public piaMessage: string = "If you don’t know your client’s PIA and want to calculate it manually, check this box and follow the instructions that appear.";
public pensionMessage: string = "Individuals who are receiving (or are going to receive) a pension during their retirement based on working years during which they did not pay into Social Security should check this box.";
public pensionBaseMessage: string = "The government applies provisions to Social Security regulations which may decrease or eliminate a benefit or spousal benefit given to someone who is receiving a pension.";
public pensionStartMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start year is needed so as not to impose deductions in our projections that do not actually apply at that time.";
public pensionStartMonthMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start month is needed so as not to impose deductions in our projections that do not actually apply at that time.";
public pensionSubMessage: string = "Social Security measures Substantial Earnings Years by the amount of money an individual earns in a calendar year on income that is taxed by Social Security. This metric is needed to calculate deductions made to the client’s Social Security benefit by the Windfall Elimination Provision. A chart with these measures for each year can be found at http://www.ssa.gov/pubs/EN-05-10045.pdf.";

public lifeExpectancyMessage: string = "Appropriately assessing your client’s health and longevity is a top consideration for each tool on this platform. Primary drivers of life expectancy include gender, current age, and health conditions/lifestyle. The amount defaulted in the input field is based on those variables, but you may override this result if you desire.";
public primaryInsuranceAmountMessage: string = "Primary Insurance Amount is the monthly benefit the client will receive from Social Security at Full Retirement Age based on their earnings record. This amount is needed to project benefits throughout the client’s lifetime. This amount can be found at <a target='blank' href='https://secure.ssa.gov/RIL/SiView.do'>https://secure.ssa.gov/RIL/SiView.do</a>"
public nationalAverageMessage: string = `Selecting "Yes" will show all projections based on national average instead of featuring the data specific to the chosen retirement state above. This selection may be made is the client is unsure of where they will spend their retirement years or if you are running a case study and looking for generic data.`;
public previouslyMarriedMessage: string = "";

private advisor: Advisor;
public client: any = {};
private organization: Organization;

private modalData: any;

public dobYear;

private createClientModel: any = {
  client: {
    HCHBP: false,
    HCHC: false,
    HCT2D: false,
    HCCD: false,
    HCC: false,
    HCT: false,
  },
  clientProfile: {
    HCHBP: false,
    HCHC: false,
    HCT2D: false,
    HCCD: false,
    HCC: false,
    HCT: false,
    clientSpouses: [],
    clientChildren: [],
    PIAYears: {
      IncludePIA: false,
    }
  },
};

private editClientModel: any = {
  loaded: false,
  client: {
    HCHBP: false,
    HCHC: false,
    HCT2D: false,
    HCCD: false,
    HCC: false,
    HCT: false,
  },
  clientProfile: {
    HCHBP: false,
    HCHC: false,
    HCT2D: false,
    HCCD: false,
    HCC: false,
    HCT: false,
    clientSpouses: [],
    clientChildren: [],
    PIAYears: {
      IncludePIA: false,
    }
  },
};

//public modalSubscription;

public clientDOB: IMyDate = {
  year: 1970,
  month: 1,
  day: 1,
};

public testDate: IMyDate = {
  year: 0,
  month: 0,
  day: 0,
}

public clientModelV2: any = {
  generalInformation: {
    firstName: '',
    lastName: '',
    gender: '',
    dob: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    email: '',
    retirementAge: '',
    retirementState: '',
    maritalStatus: false
  },
  financialInformation: {
    currentIncome: '',
    irr: '',
    irrDollar:'',
    pia: '',
    PIAYears: {},
    pensionAmount: 0,
    pensionStartMonth: '',
    pensionStartYear: '',
    pensionSubEarnings: '',
    hasPension: '',
  },
  healthInformation: {
    HCC: false,
    HCCD: false,
    HCHBP: false,
    HCHC: false,
    HCT: false,
    HCT2D: false,
    lifeExpectancy: '',
  },
  maritalStatus: {
    maritalStatus: 'Single',
    firstName: '',
    lastName: '',
    gender: '',
    lifeExpectancy: '',
    currentIncome: '',
    pia: '',
    PIAYears: {
      includePIA: '',
      startYear: '',
      endYear: '',
      years: [],
    },
  },
  spouses: [
    { maritalStatus: 'Single' }
  ],
  maritalHistory: {
    previousSpouseCount: 0,
    previouslyMarried: false,
  },
  dependentChildren: {
    children: [],
    hasKids: false,
  }
}

d: Date = new Date();
defaultDOB = { date: { year: this.d.getFullYear() - 55, month: this.d.getMonth() + 1, day: this.d.getDate() } };
defaultDOBStr = ((this.d.getMonth() + 1 <= 9) ? "0" + (this.d.getMonth() + 1) : (this.d.getMonth() + 1)) + "/" + ((this.d.getDate() <= 9) ? "0" + this.d.getDate() : this.d.getDate()) + "/" + (this.d.getFullYear() - 55);
public isSelectingAdvisor: boolean = false;
public organizations: any;
public advisors: any;
public selectedOrganization: any;
public selectedAdvisors: any;
public selectedAdvisor: any;
public hcProjectionTotal: any = {};
public advisorObject: any;
public isEditClient: string;
public isCreateClient: string;
public isVisible: boolean;

constructor(private modalService: ModalService, private clientService: ClientService, private loadingService: LoadingService, private globalService: GlobalService, private snackBarService: SnackBarService, 
  private router: Router, private sanitizer: DomSanitizer, private _formBuilder: FormBuilder, public dialog: MatDialog) {
    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
    this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));

    this.isCreateClient = localStorage.getItem('isCreateClient');
    this.isEditClient = localStorage.getItem('isEditClient');
    this.ID = 0;
    this.modalSubscription = clientService.modal$.subscribe(modal => {
      this.isEditClient = "True";
      this.modalName = modal.modalName;
      this.modalData = modal.data;
      this.ID = modal.data.ID;
      this.initialCallFromConstructor();
      // this.open();
      this.isVisible = true;
      // if (modal.modalName.indexOf('Closed') == -1) {
      //   this.initialCallFromConstructor();
      //   // this.open();
      //   this.isVisible = true;
      // }
    });

    console.log('modal data', this.modalData);

    if (this.ID == 0 && this.isCreateClient == "True") {
      this.isEditClient = "False";
      this.currentAddEditClientScreen = 0;
      this.modalData = localStorage.getItem('advisor');
      if (this.modalData) {
        this.modalData = JSON.parse(localStorage.getItem('advisor'));
      }
    }
    if (this.isEditClient == "True") {
      this.isCreateClient = "False"
      this.currentAddEditClientScreen = Number(localStorage.getItem('currentAddEditClientScreen'));
      this.ID = Number(localStorage.getItem('selectedClient'));
      this.modalData = localStorage.getItem('selectedAdvisor');
    }
    this.initialCallFromConstructor();
    this.isVisible = true;
}

initialCallFromConstructor() {

    this.selectedAdvisor = null;
    this.selectedOrganization = null;
    this.organizations = [];
    this.selectedAdvisors = [];

    this.clientModelV2 = {
      generalInformation: {
        firstName: '',
        lastName: '',
        gender: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        useNationalAverage: false,
        retirementAge: '',
        retirementState: '',
      },
      financialInformation: {
        currentIncome: '',
        irr: '',
        pia: '',
        PIAYears: {},
        pensionAmount: 0,
        pensionStartMonth: '',
        pensionStartYear: '',
        pensionSubEarnings: '',
        hasPension: '',
      },
      healthInformation: {
        HCC: false,
        HCCD: false,
        HCHBP: false,
        HCHC: false,
        HCT: false,
        HCT2D: false,
        lifeExpectancy: '',
      },
      maritalStatus: {
        maritalStatus: 'Single',
        firstName: '',
        lastName: '',
        gender: '',
        lifeExpectancy: '',
        currentIncome: '',
        pia: '',
        PIAYears: {
          includePIA: '',
          startYear: '',
          endYear: '',
          years: [],
        },
      },
      spouses: [
        { maritalStatus: 'Single' }
      ],
      maritalHistory: {
        previousSpouseCount: 0,
        previouslyMarried: false,
        spousePreviouslyMarried: false,
      },
      dependentChildren: {
        children: [],
        hasKids: false,
      }
    }

    this.validFormInputs = [
      { isValid: false },
      { isValid: false },
      { isValid: false },
      { isValid: false },
      { isValid: false },
      { isValid: false },
    ]

    this.createClientModel = {
      client: {
      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };

    this.editClientModel = {
      loaded: false,
      client: {

      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };


    this.getData();
}

spouseProfileInfo: FormGroup;
profileInfo: FormGroup;
healthInfo: FormGroup;
spouseHealthInfo: FormGroup;
ngOnInit(): void {
  
  const youngerThanValidator = (minAge: number, maxAge: number): ValidatorFn => control =>
  //cant be older than max
  (this.globalService.calculateAgeV2(control.value)) > maxAge 
  //cant be younger than min
  || (this.globalService.calculateAgeV2(control.value)) < minAge   
    ? {invalidDate: 'Please make sure age is between ' + minAge + ' and ' + maxAge + '.' }  
    : null;

  this.profileInfo = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(24), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
    gender: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required, youngerThanValidator(18, 80)]),
    retirementAge: new FormControl(65, [Validators.required]),
    retirementState: new FormControl('', [Validators.required]),    
    //TODO: need to save this new value
    runReportWithSpouse: new FormControl(false),
    //TODO: base this on the marital status and if there is a spouse object
    isLegalSpouse: new FormControl(false),
    maritalStatus: new FormControl()
  });

  this.spouseProfileInfo = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(24), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('^[a-zA-Z \'\-\.]+')]),
    gender: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required, youngerThanValidator(18, 80)]),
    retirementAge: new FormControl(65, [Validators.required]),
    retirementState: new FormControl('', [Validators.required]),   
    //TODO: need to save this new value
    runReportWithSpouse: new FormControl(false),
    //TODO: base this on the marital status and if there is a spouse object
    isLegalSpouse: new FormControl(false),
    maritalStatus: new FormControl(),
    // dateOfMarriage: new FormControl('', [Validators.required])
  });

  this.healthInfo = new FormGroup({
    highBP: new FormControl(false),
    highChol: new FormControl(false),
    //TODO: type1 is not being return from API - need to update API
    type1Diab: new FormControl(false),
    type2Diab:  new FormControl(false),
    cardioDisease:  new FormControl(false),
    cardioDiseaseYearsDiagnosed: new FormControl(0),
    cancer:  new FormControl(false),
    cancerYearsDiagnosed: new FormControl(0),
    multSclerosis: new FormControl(false), //TODO: need to get returned per client from API
    tobacco: new FormControl(false),
    obesity: new FormControl(false),
    ptsd: new FormControl(false),
    alzheimers: new FormControl(false),
    parkinsons: new FormControl(false),
    amputation: new FormControl(false),
    depCaneWalker: new FormControl(false), //TODO: need to get returned per client from API
    famHistory: new FormControl(false), //TODO: need to get returned per client from API
    calcLifeExp: new FormControl(),
    lifeExp: new FormControl() //TODO: this should be prepopulating a drodown - no need for validation
  });

  this.spouseHealthInfo = new FormGroup({
    highBP: new FormControl(false),
    highChol: new FormControl(false),
    //TODO: type1 is not being return from API - need to update API
    type1Diab: new FormControl(false),
    type2Diab:  new FormControl(false),
    cardioDisease:  new FormControl(false),
    cardioDiseaseYearsDiagnosed: new FormControl(0),
    cancer:  new FormControl(false),
    cancerYearsDiagnosed: new FormControl(0),
    multSclerosis: new FormControl(false), //TODO: need to get returned per client from API
    tobacco:  new FormControl(false),
    obesity: new FormControl(false),
    ptsd: new FormControl(false),
    alzheimers: new FormControl(false),
    parkinsons: new FormControl(false),
    amputation: new FormControl(false),
    depCaneWalker: new FormControl(false), //TODO: need to get returned per client from API
    famHistory: new FormControl(false), //TODO: need to get returned per client from API
    calcLifeExp: new FormControl(),
    lifeExp: new FormControl()//TODO: this should be prepopulating a drodown - no need for validation
  });

  

  this.firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required]
  });
  this.secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required]
  });
  this.validateAge();




  this.createClientModel = {
    client: {

    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      clientSpouses: [
      ],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  this.editClientModel = {
    loaded: false,
    client: {

    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      clientSpouses: [
      ],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  this.minMarriedDate = new Date(this.profileInfo.value.dob);
  console.log('this.minMarriedDate ', this.minMarriedDate );
  this.maxMarriedDate = new Date();
}

/* setClientOnPageLoad: boolean = false;
setSpouseOnPageLoad: boolean = false;
setRetirementAge(event, isSpouse){
  const value = event.target.value;
  if(isSpouse){

  } else {
    if((new Date()).getFullYear() - (new Date(value)).getFullYear() > 65){
      this.profileInfo.patchValue({ retirementAge: (((new Date()).getFullYear() - (new Date(value)).getFullYear()) + 1) });
    }
  }
} */

showLegalSpouseQues(value){
  this.isLegalSpouseTurnedOn = !this.isLegalSpouseTurnedOn;
  this.profileInfo.controls['isLegalSpouse'].patchValue((this.isLegalSpouseTurnedOn) ? 1 : 0);
  console.log('this.profileInfo', this.profileInfo.value);
}

prepSpouses(count) {
  this.clientModal.maritalHistory.spouses = new Array(count);
}

handlePrint(e) {
  window.print();
}

prepSpousesSpouse(count) {
  this.clientModelV2.maritalHistory.spousesSpouse = [];

  for (var i = 0; i < count; i++) {
    if (this.clientModelV2.maritalHistory.spousesSpouse[i]) {
      this.clientModelV2.maritalHistory.spousesSpouse.push(this.clientModelV2.maritalHistory.spousesSpouse[i]);
    } else {
      this.clientModelV2.maritalHistory.spousesSpouse.push({
        tenyears: false,
        alive: true,
      });
    }
  }

}

prepChildren(count) {
  this.clientModelV2.dependentChildren.children = [];

  for (var i = 0; i < count; i++) {
    this.clientModelV2.dependentChildren.children.push({
      DependentChildAge: 0,
    })
  }
}

previousPage = 0;
updateAddEditClientScreen(page) {
  console.log('page', page);

  if(page == 0 && this.previousPage == 0){
    
    this.isSelectingAdvisor = false;
    //return;
  } else {
    this.previousPage = 1;
    this.isSelectingAdvisor = true
  }
  
  if (page == 1) {
    //if(!this.healthInfo.value.lifeExp){
      this.calculateLifeExp(false);
      //this.minAge = this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, this.showAge);  
      //this.maxAge = 100 - this.minAge + 1; 
    //}
    this.isSelectingAdvisor = false;
  }

  if (page == 2) {
    this.isSelectingAdvisor = false;
  }

  if (page == 3){
    //if(!this.spouseHealthInfo.value.lifeExp){
      this.calculateLifeExp(true);
    //}
    this.isSelectingAdvisor = false;
  }

  if (page == -1) {
    this.isSelectingAdvisor = false; //(this.ID > 0) ? true : false;

    this.advisors.forEach((a) => {
      if (a.c.ID == this.selectedAdvisor) {
        this.selectedAdvisor = a;
      }
    });

        //(currentAddEditClientScreen == -1) ? 0 : currentAddEditClientScreen - 1
    //this.validateFields(page);
    return;
  }
  
  if (page == 4) {
    this.dissabledConinueBtn = true;
  } else {
    this.dissabledConinueBtn = false;
  }

  if (page !== this.currentAddEditClientScreen) {
    this.previousAddEditClientScreen = this.currentAddEditClientScreen;
    this.currentAddEditClientScreen = page;
    //this.validateFields(page);
  }

  this.previousPage = (this.isSelectingAdvisor) ? 0 : page - 1;
  console.log('this.isSelectingAdvisor', this.isSelectingAdvisor);
}


validateAge() {
  var eighteenYearsAgo = new Date();
  this.eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
  this.ageEighteen = eighteenYearsAgo.getFullYear();
}

/* validateFields(page) {
  console.log('page', page);
  var isValid = true;
  if (page === 0) {
    isValid = isValid && this.clientModelV2.generalInformation.firstName.length > 0;
    isValid = isValid && this.clientModelV2.generalInformation.lastName.length > 0;
    isValid = isValid && (this.clientModelV2.generalInformation.gender == 1 || this.clientModelV2.generalInformation.gender == 2);      
    if (this.clientModelV2.generalInformation.dob === undefined || this.clientModelV2.generalInformation.dob === '' || this.clientModelV2.generalInformation.dob === this.defaultDOB) {

      isValid = false;

    } else {  
      isValid = isValid && this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.dobStr.length > 0;
      if (this.clientModelV2.generalInformation.dobStr) {
        const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);         
       }
      this.validateDefaultDate = this.validateDate(this.clientModelV2.generalInformation.dobStr, true);
      isValid = isValid && this.validateDefaultDate;
      
    }
    isValid = isValid && this.clientModelV2.generalInformation.retirementAge > 0;
    isValid = isValid && this.clientModelV2.generalInformation.retirementState != '' && this.clientModelV2.generalInformation.retirementState.length > 1;

    if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      isValid = isValid && this.clientModelV2.maritalStatus.firstName.length > 0;
      isValid = isValid && this.clientModelV2.maritalStatus.lastName.length > 0;
      isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);      
      if (this.clientModelV2.maritalStatus.dob === undefined || this.clientModelV2.maritalStatus.dob === '' || this.clientModelV2.maritalStatus.dob === this.defaultDOB) {  
        isValid = false; 
      } else {  
        isValid = isValid && this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.dobStr.length > 0;
        if (this.clientModelV2.maritalStatus.dobStr) {
          const spouseConvertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
          const SpouseTimeDiff = Math.abs(Date.now() - spouseConvertAge.getTime());
          this.spouseShowAge = Math.floor((SpouseTimeDiff / (1000 * 3600 * 24))/365);
         }
        this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
        isValid = isValid && this.validateDefaultDate2;        
      }
      isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
      isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;
    }
  } else if (page === 2) {
    isValid = isValid && this.clientModelV2.financialInformation.currentIncome != "" && this.clientModelV2.financialInformation.currentIncome.length > 1;
    isValid = isValid && this.clientModelV2.financialInformation.pia != "" && this.clientModelV2.financialInformation.pia.length > 1;
    if (this.clientModelV2.financialInformation.hasPension) {
      isValid = isValid && this.clientModelV2.financialInformation.pensionAmount.length > 1;
      isValid = isValid && this.clientModelV2.financialInformation.pensionStartMonth > 0;
      isValid = isValid && this.clientModelV2.financialInformation.pensionStartYear > 0;
      isValid = isValid && this.clientModelV2.financialInformation.pensionSubEarnings > 0;
      isValid = isValid && this.validateCurrency(this.clientModelV2.financialInformation.pensionAmount, 5001, 2000001, true)
    }
    isValid = isValid && this.clientModelV2.financialInformation.irr != "" && this.clientModelV2.financialInformation.irr.length > 0;

    if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      isValid = isValid && this.clientModelV2.maritalStatus.currentIncome != "" && this.clientModelV2.maritalStatus.currentIncome.length > 1;
      isValid = isValid && this.clientModelV2.maritalStatus.pia != "" && this.clientModelV2.maritalStatus.pia.length > 0;
      if (this.clientModelV2.maritalStatus.includePension) {
        isValid = this.clientModelV2.maritalStatus.pensionAmount === undefined ? false : (isValid && (this.clientModelV2.maritalStatus.pensionAmount.length > 1));
        isValid = isValid && this.clientModelV2.maritalStatus.pensionMonths > 0;
        isValid = isValid && this.clientModelV2.maritalStatus.pensionYears > 0;
        isValid = isValid && this.clientModelV2.maritalStatus.subEarnings > 0;
        isValid = this.clientModelV2.maritalStatus.pensionAmount === undefined ? false : (isValid && this.validateCurrency(this.clientModelV2.maritalStatus.pensionAmount, 0, 1000001, true));
      }
    }

  } else if (page === 1) {
    isValid = isValid && this.clientModelV2.healthInformation;
  }   
  else if (page === 3) {
    if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      if (this.clientModelV2.maritalStatus.anniversaryStr === undefined) {
        isValid = false;
      } else {
        isValid = isValid && this.clientModelV2.maritalStatus.anniversaryStr && this.clientModelV2.maritalStatus.anniversaryStr.length > 0;
        isValid = isValid && this.validateDate(this.clientModelV2.maritalStatus.anniversaryStr, true)
      }
    }
    if (isValid) {
      if (!this.clientModelV2.maritalHistory.previouslyMarried && !this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
        isValid = true;
      } else {
        if (this.clientModelV2.maritalHistory.previouslyMarried) {
          isValid = isValid && this.clientModelV2.maritalHistory.previousSpouseCount > 0;
          for (var spouse in this.clientModelV2.spouses) {
            if (Number(spouse) != 0) {
              isValid = isValid && this.clientModelV2.spouses[spouse].firstName.length > 0;
              isValid = isValid && this.clientModelV2.spouses[spouse].lastName.length > 0;
              isValid = isValid && this.clientModelV2.spouses[spouse].pia.length >= 0;
              if (this.clientModelV2.spouses[spouse].maritalStatus === 'Divorced') {
                isValid = isValid && this.clientModelV2.spouses[spouse].gender == 1 || isValid && this.clientModelV2.spouses[spouse].gender == 2;
                isValid = isValid && this.clientModelV2.spouses[spouse].dobStr && this.clientModelV2.spouses[spouse].dobStr.length > 0;
              }
            }
          }
        }

        if (this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
          isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouseCount > 0;
          for (var spouse in this.clientModelV2.maritalHistory.spousesSpouse) {
            isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].firstName.length > 0;
            isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].lastName.length > 0;
            isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].pia.length > 0;
            if (this.clientModelV2.maritalHistory.spousesSpouse[spouse].maritalStatus === 'Divorced') {
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 1 || isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 2;
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].dobStr.length > 0;
            }
          }
        }
      }
    }
  } else if (page === 4) {

    if (isValid) {
      if (this.clientModelV2.dependentChildren.hasKids) {
        for (var child in this.clientModelV2.dependentChildren.children) {
          isValid = isValid && this.clientModelV2.dependentChildren.children[child].DependentChildAge > 0;
        }
      } else {
        isValid = true;
      }
    }
  }
  if (page >= 0)
    this.validFormInputs[page].isValid = isValid;
}
 */
updateSpouses(model) {
  if (model.maritalStatus.maritalStatus == 'Single' || model.maritalStatus.maritalStatus == 'Married' || model.maritalStatus.maritalStatus == 'Divorced' || model.maritalStatus.maritalStatus == 'Widow') {

  }

  if (model.spouses.length - 1 < this.clientModelV2.maritalHistory.previousSpouseCount) {
    for (var i = 0; i <= this.clientModelV2.maritalHistory.previousSpouseCount; i++) {
      if (model.spouses[i] && model.spouses[i].maritalStatus) {

      } else {
        this.clientModelV2.spouses.push({
          maritalStatus: '',
          firstName: '',
          lastName: '',
          pia: 0,
          gender: 0,
          dobStr: '',
        });
      }
    }
  }
}


// onDateChanged(e, model, validationIndex) {

//   if (validationIndex === 0) {
//     this.clientModelV2.generalInformation.dobStr = e.formatted;
//     this.recalcLEV2(this.clientModelV2, 0)
//   } else if (validationIndex === 3) {
//     this.clientModelV2.maritalStatus.dobStr = e.formatted;
//     this.recalcLEV2(this.clientModelV2, 3)
//   } else if (4) {
//     model.dobStr = e.formatted;
//   }

// }

// onAnnDateChanged(e, model, validationIndex) {
//   model.anniversaryStr = e.formatted;
// }

canContinue(i, isButton) {
  //console.log('i', i);
  //console.log('isButton', isButton);
  if (i == 1 && !this.isClientValidLifeExpectancy()) {
    return false;
  }
  if (this.isSelectingAdvisor && this.selectedAdvisor && this.selectedOrganization){
    return true;
  }

  if(isButton){
    if(i == 0){ //check page/card form validation
      return !this.profileInfo.invalid;
    } else if(i == 1){
      return !this.healthInfo.invalid;
    } else if(i == 2){
      return !this.spouseProfileInfo.invalid;
    } else if(i == 3){
      return !this.spouseHealthInfo.invalid;
    }
  }

/*   return isButton ? this.validFormInputs[i].isValid : this.validFormInputs[i - 1] && this.validFormInputs[i - 1].isValid;//&& i < 5;
 */}

canSave() {
  if (this.profileInfo.value.runReportWithSpouse) {
    if (this.currentAddEditClientScreen == 1) {
      return this.isClientValidLifeExpectancy();
    } else {
      if (Number(this.spouseHealthInfo.value.lifeExp) < Number(this.spouseProfileInfo.value.retirementAge)) {
        this.isSpouseValidLifeExpectancy = false;
        return false
      } else {
        this.isSpouseValidLifeExpectancy = true;
        return true; //TODO: need to remove all these wierd save and validation checks
      }
    }
  } else {
    return this.isClientValidLifeExpectancy();
  }
}

isClientValidLifeExpectancy() {
  if (Number(this.healthInfo.value.lifeExp) < Number(this.profileInfo.value.retirementAge) && this.healthInfo.value.lifeExp) {
    this.isValidLifeExpectancy = false;
    return false
  } else {
    this.isValidLifeExpectancy = true;
    return true; //TODO: need to remove all these wierd save and validation checks
  }
}

/* validateAllFields() {
  this.validateFields(0);
  this.validateFields(1);
  this.validateFields(2);
  this.validateFields(3);
  this.validateFields(4);
  this.validateFields(5);
}
 */

setActiveErrorPage() {
  var page = 0;
  for (var i = 0; i < this.validFormInputs.length; i++) {
    if (!this.validFormInputs[i].isValid && page === 0) {
      page = i;
    }
  }
  if (!this.isEditClient) {
    this.currentAddEditClientScreen = page;
  }

}

handleOrgSelected(auto) {
  this.selectedAdvisors = [];
  var temp = [];

  temp = this.advisors.sort((a, b) => {
    if (a.c.FirstName.toLowerCase() < b.c.FirstName.toLowerCase()) return -1;
    if (a.c.FirstName.toLowerCase() > b.c.FirstName.toLowerCase()) return 1;
    return 0;
  });

  temp.forEach((advisor) => {
    if (advisor.o.ID == this.selectedOrganization) {
      if (advisor.c.FirstName.length > 0 && advisor.c.LastName.length > 0) {
        if (advisor.c.IsActive) {
          this.selectedAdvisors.push(advisor);
        }
      }
    }
  });

  if (auto) {
    this.selectedAdvisor = this.advisor.ID;
  } else {
    this.selectedAdvisor = 0;
  }
}


getData(): void {
  console.log('getData');
  if (this.modalData) {
    this.isSelectingAdvisor = false;
    if (this.modalData.ID > 0) {
      this.isSelectingAdvisor = false;
      this.selectedAdvisor = this.modalData.ID;
    } else if ((Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) && !this.modalData.Advisor) {
      this.isSelectingAdvisor = true;
      this.loadingService.isLoading(true);
    }
    
    // if (this.modalData.Advisor) {
    //   this.selectedAdvisor = {};
    //   this.selectedAdvisor.c = this.modalData.Advisor;
    //   this.selectedAdvisor.o = this.modalData.Advisor.OrganizationID;
    //   this.selectedOrganization = this.modalData.Advisor.OrganizationID;
    // }
  } else {
      //this.isSelectingAdvisor = true;
      if ((Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) && !this.modalData.Advisor) {
        this.isSelectingAdvisor = true;
        this.loadingService.isLoading(true);
      }
  }
  this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
    .subscribe(
      advisor => {
        this.advisor = advisor;
        console.log('this.advisor', this.advisor);
        if (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) {
          this.globalService.getOrganizationsData()
            .subscribe(
              organizations => {
                console.log('organizations', organizations);
                var temp = [];

                organizations.forEach((org) => {
                  if (org.Name.length > 0) {
                    org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                    temp.push(org);
                  }
                });

                temp = temp.sort((a, b) => {
                  if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                  if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                  return 0;
                });

                this.organizations = temp;
              },
              error => this.error = <any>error);

          this.globalService.getAdvisorsData(1)
            .subscribe(
              advisors => {
                console.log('advisors', advisors);
                this.advisors = advisors;
                if (this.isSelectingAdvisor) {
                  this.selectedOrganization = advisor.OrganizationID;
                  this.handleOrgSelected(true);
                }
              },
              error => this.error = <any>error);

            this.loadingService.isLoading(false);
        }
      },
      error => this.error = <any>error);
  
  this.globalService.getClientData(this.ID, 4)
    .subscribe(
        client => {
          this.client = client;
          this.mapToClientObject(client);

          //this.validateAllFields();
          if (client.clientProfile)
            this.setActiveErrorPage();
        },
        error => this.error = <any>error);

}


mapToClientObject(client) {
  if (client.client && client.client.FirstName) {
    // General Information
    this.clientModelV2.generalInformation.firstName = client.client.FirstName;
    this.clientModelV2.generalInformation.lastName = client.client.LastName;
    this.clientModelV2.generalInformation.gender = client.client.GenderID;
    this.clientModelV2.generalInformation.dob = {
      date: {
        year: new Date(client.client.DOB).getFullYear(),
        month: new Date(client.client.DOB).getMonth() + 1,
        day: new Date(client.client.DOB).getDate()
      }
    };

    this.currentYear = new Date().getFullYear();
    this.dateofBirth = new Date(client.client.DOB).getFullYear();
    this.yob = this.dateofBirth + 14;
    this.endOfPIAStartYear = this.currentYear - this.yob + 1;      
    this.endYear1 = this.dateofBirth + 30;
    this.endYear2 = this.dateofBirth + 80;               
    this.endOfPIAEndYear = this.endYear2 - this.endYear1 + 1;   

    this.clientModelV2.generalInformation.dobStr = client.client.DOB;    

    if (this.clientModelV2.generalInformation.dobStr) {
      const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
      const timeDiff = Math.abs(Date.now() - convertAge.getTime());
      this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365); 
     }  

    this.clientModelV2.generalInformation.address = client.client.Address;
    this.clientModelV2.generalInformation.city = client.client.City;
    this.clientModelV2.generalInformation.state = client.client.State;
    this.clientModelV2.generalInformation.zip = client.client.Zip;
    this.clientModelV2.generalInformation.phone = client.client.Phone;
    this.clientModelV2.generalInformation.email = client.client.Email;
    this.clientModelV2.generalInformation.useNationalAverage = client.clientProfile.UseNationalAverage || 0; // BP -> Add national average flag
    this.clientModelV2.generalInformation.retirementAge = client.clientProfile.RetirementAge;
    this.clientModelV2.generalInformation.retirementState = client.clientProfile.RetirementState;
    // Financial Information
    this.clientModelV2.financialInformation.currentIncome = this.formatCurrencyV2(client.clientProfile.CurrentIncome);
    this.clientModelV2.financialInformation.irr = client.clientProfile.IRR + '%';
    this.clientModelV2.financialInformation.pia = this.formatCurrencyV2(client.clientProfile.PIA || 0);
    this.clientModelV2.financialInformation.PIAYears = JSON.parse(client.clientProfile.PIAYears) || {};
    this.clientModelV2.financialInformation.pensionAmount = this.formatCurrencyV2(client.clientProfile.Pension);
    this.clientModelV2.financialInformation.pensionStartMonth = client.clientProfile.PensionMonths;
    this.clientModelV2.financialInformation.pensionStartYear = client.clientProfile.PensionYears;
    this.clientModelV2.financialInformation.pensionSubEarnings = client.clientProfile.SubstantialEarningYears;
    this.clientModelV2.financialInformation.hasPension = client.clientProfile.IncludePension == 1 ? true : false;

    // Health Conditions
    this.clientModelV2.healthInformation.HCC = client.clientProfile.HCC == 1 ? true : false;
    this.clientModelV2.healthInformation.HCCD = client.clientProfile.HCCD == 1 ? true : false;
    this.clientModelV2.healthInformation.HCHBP = client.clientProfile.HCHBP == 1 ? true : false;
    this.clientModelV2.healthInformation.HCHC = client.clientProfile.HCHC == 1 ? true : false;
    this.clientModelV2.healthInformation.HCT = client.clientProfile.HCT == 1 ? true : false;
    this.clientModelV2.healthInformation.HCT2D = client.clientProfile.HCT2D == 1 ? true : false;
    this.clientModelV2.healthInformation.lifeExpectancy = client.clientProfile.LifeExpectancy;
   
    this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, client.clientProfile.RetirementAge + 1);//this.showAge); 
    this.minAge = this.min
    this.maxAge = 100 - this.minAge + 1;

    this.clientModelV2.spouses = JSON.parse(client.clientProfile.Spouses);

    if (this.clientModelV2.spouses[0] && this.clientModelV2.spouses[0].maritalStatus != "Single") {
      // Marital Status
      this.clientModelV2.maritalStatus.maritalStatus = typeof this.clientModelV2.spouses[0].maritalStatus === 'undefined' || typeof this.clientModelV2.spouses[0] === 'undefined' ? 'Single' : this.clientModelV2.spouses[0].maritalStatus;
      this.clientModelV2.maritalStatus.firstName = this.clientModelV2.spouses[0].firstName;
      this.clientModelV2.maritalStatus.lastName = this.clientModelV2.spouses[0].lastName;
      this.clientModelV2.maritalStatus.gender = this.clientModelV2.spouses[0].gender;
      this.clientModelV2.maritalStatus.lifeExpectancy = this.clientModelV2.spouses[0].LifeExpectancy;
      this.clientModelV2.maritalStatus.currentIncome = Utils.formatToCurrency(this.clientModelV2.spouses[0].currentIncome);
      this.clientModelV2.maritalStatus.anniversary = this.clientModelV2.spouses[0].anniversary ? {
        date: {
          year: new Date(this.clientModelV2.spouses[0].anniversary).getFullYear(),
          month: new Date(this.clientModelV2.spouses[0].anniversary).getMonth() + 1,
          day: new Date(this.clientModelV2.spouses[0].anniversary).getDate()
        }
      } : {};

    this.spouseDateofBirth = new Date(this.clientModelV2.spouses[0].anniversary).getFullYear();
    this.spouseYob = this.spouseDateofBirth + 14;
    this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
    this.spouseEndYear1 = this.spouseDateofBirth + 30;
    this.spouseEndYear2 = this.spouseDateofBirth + 80;               
    this.spouseEndOfPIAEndYear = this.spouseEndYear1 - this.spouseEndYear2 + 1; 

      this.clientModelV2.maritalStatus.anniversaryStr = this.clientModelV2.spouses[0].anniversary;

      this.clientModelV2.maritalStatus.dob = this.clientModelV2.spouses[0].dob ? {
        date: {
          year: new Date(this.clientModelV2.spouses[0].dob).getFullYear() || 0,
          month: new Date(this.clientModelV2.spouses[0].dob).getMonth() + 1 || 0,
          day: new Date(this.clientModelV2.spouses[0].dob).getDate() || 0
        }
      } : {};

      this.clientModelV2.maritalStatus.dobStr = this.clientModelV2.spouses[0].dob;


      if (this.clientModelV2.maritalStatus.dobStr) {
        const convertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.spouseShowAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);           
       } 

       this.SpouseMin = Math.min(this.clientModelV2.maritalStatus.lifeExpectancy, this.clientModelV2.spouses[0].retirementAge);//this.spouseShowAge);      
       this.spouseMinAge = this.SpouseMin
       this.spouseMaxAge = 100 - this.spouseMinAge + 1;  


      this.clientModelV2.maritalStatus.pia = this.clientModelV2.spouses[0].pia ? this.formatCurrencyV2(this.clientModelV2.spouses[0].pia.replace(/,/g, '').replace('$', '')) : this.formatCurrencyV2(0);
      this.clientModelV2.maritalStatus.PIAYears = this.clientModelV2.spouses[0].PIAYears || {};
      this.clientModelV2.maritalStatus.PIAYears.includePIA = this.clientModelV2.maritalStatus.PIAYears.IncludePIA;
      this.clientModelV2.maritalStatus.PIAYears.startYear = this.clientModelV2.maritalStatus.PIAYears.StartYear;
      this.clientModelV2.maritalStatus.PIAYears.endYear = this.clientModelV2.maritalStatus.PIAYears.EndYear;
      this.clientModelV2.maritalStatus.PIAYears.years = this.clientModelV2.maritalStatus.PIAYears.Years;
      this.clientModelV2.maritalStatus.includePension = this.clientModelV2.spouses[0].includePension;
      this.clientModelV2.maritalStatus.pensionAmount = this.formatCurrencyV2(this.clientModelV2.spouses[0].pension || this.clientModelV2.spouses[0].pensionAmount || 0);
      this.clientModelV2.maritalStatus.pensionMonths = this.clientModelV2.spouses[0].pensionMonth;
      this.clientModelV2.maritalStatus.pensionYears = this.clientModelV2.spouses[0].pensionYear;
      this.clientModelV2.maritalStatus.subEarnings = this.clientModelV2.spouses[0].substantialEarningYears;
      this.clientModelV2.maritalStatus.retirementAge = this.clientModelV2.spouses[0].retirementAge;
      this.clientModelV2.maritalStatus.retirementState = this.clientModelV2.spouses[0].state;
      this.clientModelV2.maritalStatus.HCC = this.clientModelV2.spouses[0].HCC == 1 ? true : false;
      this.clientModelV2.maritalStatus.HCCD = this.clientModelV2.spouses[0].HCCD == 1 ? true : false;
      this.clientModelV2.maritalStatus.HCHBP = this.clientModelV2.spouses[0].HCHBP == 1 ? true : false;
      this.clientModelV2.maritalStatus.HCHC = this.clientModelV2.spouses[0].HCHC == 1 ? true : false;
      this.clientModelV2.maritalStatus.HCT = this.clientModelV2.spouses[0].HCT == 1 ? true : false;
      this.clientModelV2.maritalStatus.HCT2D = this.clientModelV2.spouses[0].HCT2D == 1 ? true : false;
    } else {
      this.clientModelV2.maritalStatus.maritalStatus = 'Single';
    }


    if (this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
      // Marital History
      this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
      this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; //this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
      this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
      this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

      this.clientModelV2.maritalHistory.spousePreviouslyMarried = false;
      this.clientModelV2.maritalHistory.spousesSpouseCount = 0;
      this.clientModelV2.maritalHistory.spousesSpouse = [];
    } else {
      // Marital History
      this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
      this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; // this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
      this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
      this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

      this.clientModelV2.spouses[0].maritalHistory = this.clientModelV2.spouses[0].maritalHistory || {};
      this.clientModelV2.maritalHistory.spousePreviouslyMarried = this.clientModelV2.spouses[0].maritalHistory.spousePreviouslyMarried || false;
      this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.spouses[0].maritalHistory.spousesSpouseCount || 0;
      this.clientModelV2.maritalHistory.spousesSpouse = this.clientModelV2.spouses[0].spousesSpouse || [];
    }

    if (!client.clientProfile.LifeExpectancy || client.clientProfile.LifeExpectancy == null) {
      if (this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.gender && this.clientModelV2.generalInformation.dobStr) {
        var leModel = this.clientModelV2.healthInformation;
        leModel.gender = this.clientModelV2.generalInformation.gender;
        leModel.dob = this.clientModelV2.generalInformation.dobStr;
        this.recalcLEV2(this.clientModelV2, 0, true);
      }
    }

    // Dependent Children
    var children = JSON.parse(client.clientProfile.Children) || [];

    this.clientModelV2.dependentChildren.children = children.children || children;
    this.clientModelV2.dependentChildren.hasKids = children.hasKids || children.length > 0;
    this.clientModelV2.dependentChildren.childrenCount = children.childrenCount || children.length;

  }
}

clientCreateClicked: boolean = false;

saveClientV2(client, directToReports) {
  let AdvisorID = this.selectedAdvisor;
  let AdvisorOrgID = this.selectedOrganization;

  if (this.canSave() && !this.clientCreateClicked) {
    this.clientCreateClicked = true;
    this.loadingService.isLoading(true);
    let clientDOB = ((new Date(this.profileInfo.value.dob).getMonth()) + 1) + '/' + new Date(this.profileInfo.value.dob).getDate() + '/' + new Date(this.profileInfo.value.dob).getFullYear() + ' 00:00:00';

    var UserModel = {
      AdvisorID: AdvisorID || this.advisor.ID,
      OrganizationID: AdvisorOrgID || this.advisor.OrganizationID,

      ID: this.client.client ? this.client.client.ID : 0,
      Username: '',//this.clientModelV2.generalInformation.email,
      Email: '',//this.clientModelV2.generalInformation.email,
      FirstName: this.profileInfo.value.firstName,
      LastName: this.profileInfo.value.lastName,
      Address: '',//this.clientModelV2.generalInformation.address,
      City: '',//this.clientModelV2.generalInformation.city,
      State: '',//this.clientModelV2.generalInformation.state,
      Zip: '',//this.clientModelV2.generalInformation.zip,
      Phone: '',//this.clientModelV2.generalInformation.phone,
      // DOB: this.profileInfo.value.dob,
      DOB: clientDOB,
      GenderID: Number(this.profileInfo.value.gender),
    }

    var spouses = [];

    //if (this.clientModelV2.maritalStatus.maritalStatus != 'Single') {
    if (this.profileInfo.value.runReportWithSpouse) {
      let spouseDOB = ((new Date(this.spouseProfileInfo.value.dob).getMonth()) + 1) + '/' + new Date(this.spouseProfileInfo.value.dob).getDate() + '/' + new Date(this.spouseProfileInfo.value.dob).getFullYear() + ' 00:00:00';
      let spouuseRetirementAge = Number(this.spouseProfileInfo.value.retirementAge);
      if (Number(this.spouseHealthInfo.value.lifeExp) > 0) {
        spouuseRetirementAge = Number(this.spouseProfileInfo.value.retirementAge) >= Number(this.spouseHealthInfo.value.lifeExp) ? Number(this.spouseHealthInfo.value.lifeExp) - 1 : Number(this.spouseProfileInfo.value.retirementAge);
      }
      spouses[0] = { PIAYears: {} };
      //spouses[0].PIAYears.IncludePIA = this.clientModelV2.maritalStatus.PIAYears.includePIA;
      //spouses[0].PIAYears.StartYear = this.clientModelV2.maritalStatus.PIAYears.startYear;
      //spouses[0].PIAYears.EndYear = this.clientModelV2.maritalStatus.PIAYears.endYear;
      //spouses[0].PIAYears.Years = this.clientModelV2.maritalStatus.PIAYears.years;
      //spouses[0].previouslyMarried = this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
      //spouses[0].tenyears = this.clientModelV2.maritalHistory.tenyears;
      //spouses[0].alive = this.clientModelV2.maritalHistory.alive;
      spouses[0].maritalStatus = 'Married';//this.clientModelV2.maritalStatus.maritalStatus;
      spouses[0].firstName = this.spouseProfileInfo.value.firstName;//this.clientModelV2.maritalStatus.firstName;
      spouses[0].lastName = this.spouseProfileInfo.value.lastName;//this.clientModelV2.maritalStatus.lastName;
      spouses[0].dob = spouseDOB;// need to pass est format same as client one
      //spouses[0].anniversary = this.clientModelV2.maritalStatus.anniversaryStr;
      //spouses[0].currentIncome = this.getNumber(this.clientModelV2.maritalStatus.currentIncome);
      //spouses[0].pia = this.clientModelV2.maritalStatus.pia.replace(/,/g, "").replace("$", "") || 0;
      spouses[0].gender = this.spouseProfileInfo.value.gender;//this.clientModelV2.maritalStatus.gender;
      spouses[0].LifeExpectancy = this.spouseHealthInfo.value.lifeExp;//this.clientModelV2.maritalStatus.lifeExpectancy;
      spouses[0].retirementAge = spouuseRetirementAge;//this.clientModelV2.maritalStatus.retirementAge;
      spouses[0].state = this.spouseProfileInfo.value.retirementState;//this.clientModelV2.maritalStatus.retirementState;
      //spouses[0].pension = this.clientModelV2.maritalStatus.pensionAmount || 0;
      //spouses[0].includePension = this.clientModelV2.maritalStatus.includePension || false;
      //spouses[0].pensionYear = this.clientModelV2.maritalStatus.pensionYears;
      //spouses[0].pensionMonth = this.clientModelV2.maritalStatus.pensionMonths;
      //spouses[0].substantialEarningYears = this.clientModelV2.maritalStatus.subEarnings;
      spouses[0].HCT2D = (this.spouseHealthInfo.value.type2Diab) ? 1 : 0;//this.clientModelV2.maritalStatus.HCT2D == true ? 1 : 0;
      spouses[0].HCHBP = (this.spouseHealthInfo.value.highBP) ? 1 : 0;//this.clientModelV2.maritalStatus.HCHBP == true ? 1 : 0;
      spouses[0].HCC = (this.spouseHealthInfo.value.cancer) ? 1 : 0;//this.clientModelV2.maritalStatus.HCC == true ? 1 : 0;
      spouses[0].HCCYrsDiag = parseInt(this.spouseHealthInfo.value.cancerYearsDiagnosed || 0);
      spouses[0].HCHC = (this.spouseHealthInfo.value.highChol) ? 1 : 0;//this.clientModelV2.maritalStatus.HCHC == true ? 1 : 0;
      spouses[0].HCCD = (this.spouseHealthInfo.value.cardioDisease) ? 1 : 0;//this.clientModelV2.maritalStatus.HCCD == true ? 1 : 0;
      spouses[0].HCCDYrsDiag = parseInt(this.spouseHealthInfo.value.cardioDiseaseYearsDiagnosed || 0);
      spouses[0].HCT = (this.spouseHealthInfo.value.tobacco) ? 1 : 0;//this.clientModelV2.maritalStatus.HCT == true ? 1 : 0;
      spouses[0].HCT1D = (this.spouseHealthInfo.value.type1Diab) ? 1 : 0;
      spouses[0].HCMS = (this.spouseHealthInfo.value.multSclerosis) ? 1 : 0;
      spouses[0].HCDCW = (this.spouseHealthInfo.value.depCaneWalker) ? 1 : 0;
      spouses[0].HCFHDC = (this.spouseHealthInfo.value.famHistory) ? 1 : 0;

      spouses[0].HCALZ = (this.spouseHealthInfo.value.alzheimers) ? 1 : 0;
      spouses[0].HCPARK = (this.spouseHealthInfo.value.parkinsons) ? 1 : 0;
      spouses[0].HCAMP = (this.spouseHealthInfo.value.amputation) ? 1 : 0;
      spouses[0].HCPTSD = (this.spouseHealthInfo.value.ptsd) ? 1 : 0;
      spouses[0].HCOBS = (this.spouseHealthInfo.value.obesity) ? 1 : 0;

      spouses[0].isLegalSpouse = this.profileInfo.value.isLegalSpouse > 0 ? 1: 0;
      // if (this.profileInfo.value.isLegalSpouse > 0) {
      //   spouses[0].anniversary = this.spouseProfileInfo.value.dateOfMarriage;
      // }
      //spouses[0].spousesSpouse = this.clientModelV2.maritalHistory.spousesSpouse || [];
      //spouses[0].maritalHistory = this.clientModelV2.maritalHistory || {};
    } else {

      //TODO: need to allow looping of profiles in the API when in this ELSE
      spouses[0] = { PIAYears: {} };
      spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
      spouses[0].pia = '';
      spouses[0].pension = '';
      spouses[0].previouslyMarried = false;//this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
    }
    let retirementAge = Number(this.profileInfo.value.retirementAge);
    if (Number(this.healthInfo.value.lifeExp) > 0) {
      retirementAge = Number(this.profileInfo.value.retirementAge) >= Number(this.healthInfo.value.lifeExp) ? Number(this.healthInfo.value.lifeExp) - 1 : Number(this.profileInfo.value.retirementAge);
    }
    
    var ClientProfile = {
      //CurrentIncome: this.getNumber(this.clientModelV2.financialInformation.currentIncome),
      //IRR: this.getNumber(this.clientModelV2.financialInformation.irr),
      //PIA: this.getNumber(this.clientModelV2.financialInformation.pia),
      RetirementAge: retirementAge,
      UseNationalAverage: 0,//Number(this.clientModelV2.generalInformation.useNationalAverage || 0) || 0,
      //Pension: this.getNumber(this.clientModelV2.financialInformation.pensionAmount),
      //PensionMonths: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartMonth)),
      //PensionYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartYear)),
      //SubstantialEarningYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionSubEarnings)),
      RetirementState: this.profileInfo.value.retirementState,//this.clientModelV2.generalInformation.retirementState,
      HCHBP: (this.healthInfo.value.highBP) ? 1 : 0, //this.clientModelV2.healthInformation.HCHBP ? 1 : 0,
      HCHC: (this.healthInfo.value.highChol) ? 1 : 0, //this.clientModelV2.healthInformation.HCHC ? 1 : 0,
      HCT2D: (this.healthInfo.value.type2Diab) ? 1 : 0, //this.clientModelV2.healthInformation.HCT2D ? 1 : 0,
      HCCD: (this.healthInfo.value.cardioDisease) ? 1 : 0, //this.clientModelV2.healthInformation.HCCD ? 1 : 0,
      HCCDYrsDiag: parseInt(this.healthInfo.value.cardioDiseaseYearsDiagnosed || 0),
      HCC: (this.healthInfo.value.cancer) ? 1 : 0, //this.clientModelV2.healthInformation.HCC ? 1 : 0,
      HCCYrsDiag: parseInt(this.healthInfo.value.cancerYearsDiagnosed || 0),
      HCT: (this.healthInfo.value.tobacco) ? 1 : 0, //this.clientModelV2.healthInformation.HCT ? 1 : 0,
      HCT1D: (this.healthInfo.value.type1Diab) ? 1 : 0,
      HCMS: (this.healthInfo.value.multSclerosis) ? 1 : 0,
      HCDCW: (this.healthInfo.value.depCaneWalker) ? 1 : 0,
      HCFHDC: (this.healthInfo.value.famHistory) ? 1 : 0,

      HCALZ: (this.healthInfo.value.alzheimers) ? 1 : 0,
      HCPARK: (this.healthInfo.value.parkinsons) ? 1 : 0,
      HCAMP: (this.healthInfo.value.amputation) ? 1 : 0,
      HCPTSD: (this.healthInfo.value.ptsd) ? 1 : 0,
      HCOBS: (this.healthInfo.value.obesity) ? 1 : 0,

      Spouses: JSON.stringify(spouses), //this.client.clientProfile.Spouses, // order them so first is always the one being claimed off of
      //Children: this.clientModelV2.dependentChildren.hasKids ? JSON.stringify(this.clientModelV2.dependentChildren.children) : JSON.stringify([]), //this.client.clientProfile.Children,
      IncludePension: 0,//this.clientModelV2.financialInformation.hasPension ? 1 : 0,
      LifeExpectancy: Number(this.healthInfo.value.lifeExp),// Number(this.clientModelV2.healthInformation.lifeExpectancy),
      //PIAYears: JSON.stringify(this.clientModelV2.financialInformation.PIAYears),
      IsRunReportWithSpouse: this.profileInfo.value.runReportWithSpouse,
      IsLegalSpouse: this.profileInfo.value.runReportWithSpouse ? (this.profileInfo.value.isLegalSpouse == '1'? true: false): null,
    }
    console.log('UserModel', UserModel)
    console.log('ClientProfile', ClientProfile)
    var RiskTolerance = null;


    if (true) { // validate fields again?
      this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
        .subscribe(
          resp => {
            console.log('create user', resp)
            this.loadingService.isLoading(false);
            if (resp.type != 0) {
              if (!this.client.clientProfile) {
                this.globalService.getClientsData()
                  .subscribe(
                    clients => {
                      UserModel.ID = resp.message;
                      //this.snackBarService.add('To create a report for ' + UserModel.FirstName + ' ' + UserModel.LastName + ', please click ', 0, 1, 10000);

                    },
                    error => {
                      this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                      this.error = <any>error;

                    });
              } else {
                this.snackBarService.add('Client has been updated', 0);

              }

              localStorage.setItem('selectedClient', resp.message);
              localStorage.setItem('selectedAdvisorID', AdvisorID);
              localStorage.setItem('selectedAdvisorOrgID', this.selectedOrganization);
              if(this.checkIfDisplayReportSelectionPage()){
                this.router.navigate(['reports/new']);
              } else {
                //re-route to only report avail to this org
                this.router.navigate([this.rerouteReportURL]);
              }

              //this.snackBarService.add('Successfully create the client.', 1);
              // call life expectancy
              console.log('after router navigate');
              // if life expectance is less than retirement age then override retirement age

            } else {
              this.snackBarService.add('An error occured creating this client.', 1);
            }

          },
          error => {
            this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
            this.error = <any>error;
            this.loadingService.isLoading(false);
          });

    } else {
      //this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    }
  }
}

rerouteReportURL;
checkIfDisplayReportSelectionPage(){
  var i = 0;

  if(this.globalService.featHealthCare){
    i += 1;
    this.rerouteReportURL = '/clients/edit/healthcare';
  }
  
  if(this.globalService.featSocialSecurity){
    i += 1;
    this.rerouteReportURL = '/clients/edit/social-security';
  }
  
  if(this.globalService.featLongTermCare){
    i += 1;
    this.rerouteReportURL = '/clients/edit/long-term-care';
  }

  if(this.globalService.featMeansTesting){
    i += 1;
    this.rerouteReportURL = '/clients/edit/healthcare';
  }
  
  if(this.globalService.featCombinedHealthcareLTC){    
    i += 1;
    this.rerouteReportURL = '/clients/edit/combined';
  }

  if(i > 1){
    return true;
  } else {
    return false;
  }
}


ngAfterViewChecked() {
}


onClick(e): void {
  if (this.container.nativeElement.classList.contains('visible')) {

  }
}

open(): void {
  this.container.nativeElement.classList.remove('hidden');
  this.container.nativeElement.classList.add('visible');
  // this.scrollEl.nativeElement.scrollTop = 0;
}

close(): void {
  this.isVisible = false;
}

createClient() {
  var UserModel = {
    AdvisorID: this.advisor.ID,
    OrganizationID: this.advisor.OrganizationID,
    Username: this.createClientModel.client.email || " ",
    Email: this.createClientModel.client.email || " ",
    FirstName: this.createClientModel.client.firstName,
    LastName: this.createClientModel.client.lastName,
    Address: this.createClientModel.client.address,
    City: this.createClientModel.client.city,
    State: this.createClientModel.client.state,
    Zip: Number(this.createClientModel.client.zip.toString().substring(0, 5)),
    Phone: this.createClientModel.client.phone,
    DOB: this.createClientModel.client.DOB,
    GenderID: Number(this.createClientModel.client.gender),
  }


  if (this.createClientModel.clientProfile.clientSpouses.length) {
    for (var k in this.createClientModel.clientProfile.clientSpouses) {
      this.createClientModel.clientProfile.clientSpouses[k].currentIncome = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].currentIncome);
      this.createClientModel.clientProfile.clientSpouses[k].pension = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].pension);
      this.createClientModel.clientProfile.clientSpouses[k].PIAYears = this.createClientModel.clientProfile.clientSpouses[k].PIAYears;
    }
  }

  var tempSpouses = [];
  var tempSpouse = {};

  for (var i = 0; i < this.createClientModel.clientProfile.clientSpouses.length; i++) {
    tempSpouse = {};
    for (var j in this.createClientModel.clientProfile.clientSpouses[i]) {
      if (j === "HCHBP") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else if (j === "HCHC") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else if (j === "HCT2D") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else if (j === "HCCD") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else if (j === "HCC") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else if (j === "HCT") {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
      } else {
        tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j];
      }
    }

    tempSpouses.push(tempSpouse);
  }

  var ClientProfile = {
    CurrentIncome: this.getNumber(this.createClientModel.clientProfile.currentIncome),
    IRR: this.getNumber(this.createClientModel.clientProfile.IRR),
    PIA: this.getNumber(this.createClientModel.clientProfile.PIA),
    PIAYears: JSON.stringify(this.createClientModel.clientProfile.PIAYears),
    RetirementAge: this.getNumber(Number(this.createClientModel.clientProfile.retirementAge)),
    Pension: this.getNumber(this.createClientModel.clientProfile.pension),
    PensionMonths: this.getNumber(Number(this.createClientModel.clientProfile.pensionMonth)),
    PensionYears: this.getNumber(Number(this.createClientModel.clientProfile.pensionYear)),
    SubstantialEarningYears: this.getNumber(Number(this.createClientModel.clientProfile.substantialEarningYears)),
    RetirementState: this.createClientModel.clientProfile.retirementState,
    HCHBP: this.createClientModel.clientProfile.HCHBP ? 1 : 0,
    HCHC: this.createClientModel.clientProfile.HCHC ? 1 : 0,
    HCT2D: this.createClientModel.clientProfile.HCT2D ? 1 : 0,
    HCCD: this.createClientModel.clientProfile.HCCD ? 1 : 0,
    HCC: this.createClientModel.clientProfile.HCC ? 1 : 0,
    HCT: this.createClientModel.clientProfile.HCT ? 1 : 0,
    HCT1D: this.healthInfo.value.type1Diab,
    HCMS: this.healthInfo.value.multSclerosis,
    HCDCW: this.healthInfo.value.depCaneWalker,
    HCFHDC: this.healthInfo.value.famHistory,
    Spouses: JSON.stringify(tempSpouses), // order them so first is always the one being claimed off of
    Children: JSON.stringify(this.createClientModel.clientProfile.clientChildren),
    IncludePension: this.createClientModel.clientProfile.includePension ? 1 : 0,
    LifeExpectancy: Number(this.createClientModel.clientProfile.LifeExpectancy),
    IsRunReportWithSpouse: this.profileInfo.value.runReportWithSpouse,
    IsLegalSpouse: this.profileInfo.value.runReportWithSpouse ? this.profileInfo.value.isLegalSpouse: null,
    

  }

  var RiskTolerance = null;

  var validationErrors = this.validateCreateClient();

  console.log('ClientProfile', ClientProfile);

  // if (validationErrors) {
  //   this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
  //     .subscribe(
  //       resp => {
  //         if (resp.type != 0) {
  //           this.close();
  //           this.globalService.getClientsData()
  //             .subscribe(
  //               clients => {
  //                 var client = clients[clients.length - 1].c || clients[clients.length - 1];

  //                 localStorage.setItem('selectedClient', client.ID);
  //                 this.snackBarService.add('To create a report for ' + client.FirstName + ' ' + client.LastName + ', please click ', 0, 1, 10000);
  //               },
  //               error => {
  //                 this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
  //                 this.error = <any>error;
  //               });
  //         } else {
  //           this.snackBarService.add('An error occured creating this client.', 1);
  //         }

  //       },
  //       error => {
  //         this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
  //         this.error = <any>error;

  //       });
  // } else {
  //   this.snackBarService.add('Please make sure all fields are properly filled out', 1);
  // }




}

removeSpouse(index, from) {

  if (!this.editClientModel.clientProfile.Spouses) {
    this.editClientModel.clientProfile.Spouses = [];
  }

  if (from == 'edit') {
    this.editClientModel.clientProfile.Spouses.splice(index, 1);
  } else if (from == 'create') {
    this.createClientModel.clientProfile.clientSpouses.splice(index, 1);
  }

  if (from == 'marital-history') {
    this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.maritalHistory.previousSpouseCount - 1;
    this.clientModelV2.spouses.splice(index + 1, 1);
  } else if (from == 'spouse-history') {
    this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.maritalHistory.spousesSpouseCount - 1;
    this.clientModelV2.maritalHistory.spousesSpouse.splice(index, 1);
  }

  //this.validateAllFields();
}


validateString(val, isRequired) {
  var regex = /^[a-zA-Z ]{2,25}$/;
  return val ? regex.test(val) : !isRequired;
}


validatePhoneNumber(val, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g) : '';
  return val ? numbers.length === 10 : !isRequired;
}

validateZip(val, isRequired) {
  return true;
}

validateCurrency(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

validateEmail(val, isRequired) {
  var regex = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return val ? regex.test(val) : !isRequired;
}


validateDate(val, isRequired) {
  var regex = /^([0-9]{1}|[0-9]{2})\/([0-9]{1}|[0-9]{2})\/([0-9]{4})$/;
  return val ? regex.test(val) : !isRequired;
}

validatePercent(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

validateNumber(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

getNumber(val) {
  val = val ? val.toString() : '';
  val = val.replace('$', '').replace(',', '');
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? numbers : 0
}

formatString(model, field) {
  if (model[field])
    model[field] = model[field].charAt(0).toUpperCase() + model[field].slice(1);
}




formatNumber(model, field) {
  var numbers = model[field] ? model[field].match(/\d/g) : '';
  model[field] = numbers.join('');
}

formatPercent(model, field, e) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    if (e.keyCode && (e.keyCode == 8 || e.keyCode == 46))
      numbers.pop();

    model[field] = numbers.join('') + '%';
  }
}

formatCurrency(model, field) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    model[field] = '$' + numbers.join('').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}

formatCurrencyV2(amount) {
  amount = amount.toString().replace(/,/g, "").replace("$", "");
  return Utils.formatToCurrency(amount);
}

formatPhoneNumber(model, field) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    if (numbers.length < 3) {
      model[field] = "(" + numbers.join('');
    } else if (numbers.length < 4) {
      model[field] = "(" + numbers.join('') + ")";
    } else if (numbers.length < 7) {
      model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, numbers.length);
    } else if (numbers.length >= 7) {
      model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, 6) + "-" + numbers.join('').substring(6, 10);
    }
  }

}

formatToString(section){  
  if(section == 'clientFirstName'){
    this.profileInfo.controls['firstName'].patchValue(Utils.formatToString(this.profileInfo.value.firstName));
  } else if(section == 'clientLastName'){
    this.profileInfo.controls['lastName'].patchValue(Utils.formatToString(this.profileInfo.value.lastName).replace(/\s/g, ""));
  } else if(section == 'spouseFirstName'){
    this.spouseProfileInfo.controls['firstName'].patchValue(Utils.formatToString(this.spouseProfileInfo.value.firstName));
  } else if(section == 'spouseLastName'){
    this.spouseProfileInfo.controls['lastName'].patchValue(Utils.formatToString(this.spouseProfileInfo.value.lastName));
  }
}

validateCreateClient() {
  var result = true;
  result = result && this.validateString(this.createClientModel.client.firstName, true);
  result = result && this.validateString(this.createClientModel.client.lastName, true);

  result = result && this.validateString(this.createClientModel.client.state, false);
  result = result && this.validateZip(this.createClientModel.client.zip, false);
  result = result && this.validatePhoneNumber(this.createClientModel.client.phone, false);
  result = result && this.validateDate(this.createClientModel.client.DOB, true);
  result = result && this.validateNumber(this.createClientModel.client.gender, 1, 3, true);

  result = result && this.validateCurrency(this.createClientModel.clientProfile.currentIncome, 0, 1000000, true);
  result = result && this.validatePercent(this.createClientModel.clientProfile.IRR, 50, 201, true);
  result = result && this.validateCurrency(this.createClientModel.clientProfile.PIA, 0, 5000, true);
  result = result && this.validateNumber(this.createClientModel.clientProfile.retirementAge, 1, 71, true);
  result = result && this.validateCurrency(this.createClientModel.clientProfile.pension, 1, 400000, false);
  result = result && this.validateNumber(this.createClientModel.clientProfile.pensionMonth, 1, 13, false);
  result = result && this.validateNumber(this.createClientModel.clientProfile.pensionYear, 2000, 2061, false);
  result = result && this.validateNumber(this.createClientModel.clientProfile.substantialEarningYears, 0, 31, false);
  result = result && this.validateString(this.createClientModel.clientProfile.retirementState, true);

  for (var k in this.createClientModel.clientProfile.clientSpouses) {
    if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Married') {
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);
      result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].currentIncome, 0, 1000000, true);
      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].retirementAge, 1, 71, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].state, true);
    } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Divorced') {
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);

      if (this.createClientModel.clientProfile.clientSpouses[k].alive == 'true') {
        result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
      }

      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
      result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
    } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Widowed') {
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
      result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
      result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, true);
    }
  }
  return result;
}

calculateAge(birthday) {
  birthday = new Date(birthday);
  var ageDifMs = Date.now() - birthday;
  var ageDate = new Date(ageDifMs);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

public clientOverriddenLE:boolean = false;
public spouseOverriddenLE:boolean = false;

checkBoxCheck(event, isSpouse){
  console.log('check', event.target.value);
  console.log('check', event.currentTarget.checked);

  if (!isSpouse && this.clientOverriddenLE)
    this.clientOverriddenLE = false;

  if (isSpouse && this.spouseOverriddenLE)
    this.spouseOverriddenLE = false;

  this.calculateLifeExp(isSpouse);
}

overrodeLE(isSpouse: boolean) {
  if (isSpouse)
    this.spouseOverriddenLE = true;
  else
    this.clientOverriddenLE = true;
}

calculateLifeExp(isSpouse){
  var LEObject;
  var profileInfo = (isSpouse) ? this.spouseProfileInfo : this.profileInfo; 
  var healthInfo = (isSpouse) ? this.spouseHealthInfo : this.healthInfo;

  console.log('le profile', profileInfo);
  LEObject = {
    gender: Number(profileInfo.value.gender),
    age: this.calculateAge(profileInfo.value.dob),
    healthConditions: {
      HCC: healthInfo.value.cancer ? 1 : 0,
      HCCD: healthInfo.value.cardioDisease ? 1 : 0,
      HCHBP: healthInfo.value.highBP ? 1 : 0,
      HCHC: healthInfo.value.highChol ? 1 : 0,
      HCT: healthInfo.value.tobacco ? 1 : 0,
      HCT2D: healthInfo.value.type2Diab ? 1 : 0,
      HCT1D: (healthInfo.value.type1Diab) ? 1 : 0,
      HCMS: (healthInfo.value.multSclerosis) ? 1 : 0,
      HCDCW: (healthInfo.value.depCaneWalker) ? 1 : 0,
      HCFHDC: (healthInfo.value.famHistory) ? 1 : 0,
      HCCYrsDiag: healthInfo.value.cancerYearsDiagnosed,
      HCCDYrsDiag: healthInfo.value.cardioDiseaseYearsDiagnosed,

      HCALZ: (healthInfo.value.alzheimers) ? 1 : 0,
      HCPARK: (healthInfo.value.parkinsons) ? 1 : 0,
      HCAMP: (healthInfo.value.amputation) ? 1 : 0,
      HCPTSD: (healthInfo.value.ptsd) ? 1 : 0,
      HCOBS: (healthInfo.value.obesity) ? 1 : 0,
    }
  }

  console.log('LEObject',LEObject);
  
  if (!isSpouse && this.clientOverriddenLE)
    return;

  if (isSpouse && this.spouseOverriddenLE)
    return;

  //this will just set/patch the existing form that is set for client or spouse when called
  this.globalService.getLE(LEObject)
    .subscribe(
      le => {      
        healthInfo.patchValue({ lifeExp: parseInt(le) });
        //if(!healthInfo.value.calcLifeExp){
          healthInfo.patchValue({ calcLifeExp: parseInt(le) });          
        //}
        // check life expectancy is lesser than retirement age
        const convertAge = new Date(profileInfo.value.dob);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);

        this.minAge = Math.min(parseInt(le), parseInt(profileInfo.value.retirementAge) + 1);//this.showAge);  
        this.minAge = Math.max(this.globalService.calculateAgeV2(profileInfo.value.dob) + 1, this.minAge);
        this.maxAge = 100 - this.minAge + 1;

      },
      error => { this.error = <any>error; });
}

recalcLEV2(model, index, firstLoad = false) {
  var LEObject;

  if (index === 0) {
    if (model.generalInformation.dobStr && model.generalInformation.gender) {
      LEObject = {
        gender: Number(model.generalInformation.gender),
        age: this.calculateAge(model.generalInformation.dobStr),
        healthConditions: {
          HCC: model.healthInformation.HCC ? 1 : 0,
          HCCD: model.healthInformation.HCCD ? 1 : 0,
          HCHBP: model.healthInformation.HCHBP ? 1 : 0,
          HCHC: model.healthInformation.HCHC ? 1 : 0,
          HCT: model.healthInformation.HCT ? 1 : 0,
          HCT2D: model.healthInformation.HCT2D ? 1 : 0,

          HCALZ: model.healthInformation.HCALZ ? 1 : 0,
          HCPARK: model.healthInformation.HCPARK ? 1 : 0,
          HCAMP: model.healthInformation.HCAMP ? 1 : 0,
          HCPTSD: model.healthInformation.HCPTSD ? 1 : 0,
          HCOBS: model.healthInformation.HCOBS ? 1 : 0,
        }
      }
    }
  } else if (index === 3) {
    if (model.maritalStatus.dobStr && model.maritalStatus.gender) {
      LEObject = {
        gender: Number(model.maritalStatus.gender),
        age: this.calculateAge(model.maritalStatus.dobStr),
        healthConditions: {
          HCC: model.maritalStatus.HCC ? 1 : 0,
          HCCD: model.maritalStatus.HCCD ? 1 : 0,
          HCHBP: model.maritalStatus.HCHBP ? 1 : 0,
          HCHC: model.maritalStatus.HCHC ? 1 : 0,
          HCT: model.maritalStatus.HCT ? 1 : 0,
          HCT2D: model.maritalStatus.HCT2D ? 1 : 0,

          HCALZ: model.maritalStatus.HCALZ ? 1 : 0,
          HCPARK: model.maritalStatus.HCPARK ? 1 : 0,
          HCAMP: model.maritalStatus.HCAMP ? 1 : 0,
          HCPTSD: model.maritalStatus.HCPTSD ? 1 : 0,
          HCOBS: model.maritalStatus.HCOBS ? 1 : 0,
        }
      }
    }
  }

  this.globalService.getLE(LEObject)
    .subscribe(
      le => {
        if (index === 0) {
          model.healthInformation.lifeExpectancy = le;
          this.clientModelV2.healthInformation.lifeExpectancy = le;
          this.min = Math.min(le, this.profileInfo.value.retirementAge + 1);//this.showAge);
          this.minAge = this.min;
          this.maxAge = 100 - this.minAge + 1;
        } else if (index === 3) {
          model.maritalStatus.lifeExpectancy = le;
          this.SpouseMin = Math.min(le, this.spouseProfileInfo.value.retirementAge + 1);//this.spouseShowAge);
          this.spouseMinAge = this.SpouseMin;
          this.spouseMaxAge = 100 - this.spouseMinAge + 1;
        }

        //this.validateAllFields();
        if (this.client.clientProfile && firstLoad)
          this.setActiveErrorPage();
      },
      error => { this.error = <any>error; });


}

// recalcLE(model, type) {
//   if (model.dob) { // hack to check if it's a partner (clients dont have alive property)
//     var LEObject;

//     if (this.validateDate(model.dob, true) && model.gender) {
//       LEObject = {
//         gender: Number(model.gender),
//         age: this.calculateAge(model.dob),
//         healthConditions: {
//           HCC: model.HCC ? 1 : 0,
//           HCCD: model.HCCD ? 1 : 0,
//           HCHBP: model.HCHBP ? 1 : 0,
//           HCHC: model.HCHC ? 1 : 0,
//           HCT: model.HCT ? 1 : 0,
//           HCT2D: model.HCT2D ? 1 : 0,
//         },
//       }

//       this.globalService.getLE(LEObject)
//         .subscribe(
//           le => {
//             if (!type)
//               model.LifeExpectancy = le;
//             else if (type === 'client')
//               this.clientModelV2.healthInformation.lifeExpectancy = le;
//           },
//           error => this.error = <any>error);
//     }
//   } else {
//     if (model.client && this.validateDate(model.client.DOB, true) && (model.client.GenderID || model.client.gender)) {
//       LEObject = {
//         gender: model.client.GenderID || model.client.gender,
//         age: this.calculateAge(model.client.DOB),
//         healthConditions: {
//           HCC: model.clientProfile.HCC ? 1 : 0,
//           HCCD: model.clientProfile.HCCD ? 1 : 0,
//           HCHBP: model.clientProfile.HCHBP ? 1 : 0,
//           HCHC: model.clientProfile.HCHC ? 1 : 0,
//           HCT: model.clientProfile.HCT ? 1 : 0,
//           HCT2D: model.clientProfile.HCT2D ? 1 : 0,
//         },
//       }

//       this.globalService.getLE(LEObject)
//         .subscribe(
//           le => { model.clientProfile.LifeExpectancy = le },
//           error => this.error = <any>error);
//     }
//   }

// }

handleChange(evt, scenario) {
  var target = evt.target;
  if (target.checked && scenario == 'married') {
    this.clientModelV2.maritalStatus.maritalStatus = "Married"
  } 
  if (target.checked && scenario == 'single') {
    this.clientModelV2.maritalStatus.maritalStatus = "Single"
  }
}

ngOnDestroy() {
  console.log('ngOnDestroy');
  // localStorage.setItem('isCreateClient', "True");
  // this.isVisible = false;
}

changeIsLegalSpouse(event){
  const val = event.target.value;
  if(val == 0){
    const dialogRef = this.dialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!', 
      btnNoTitle: '',
      btnYesTitle: 'Continue',
      question: 'Unmarried partner functionality is not currently available in the Social Security Module*<br/>Please create a separate client profile to run illustrations for partner.<br/><br/><small>*This functionality will be available at a later date</small>' }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        //only need to show the modal once per client profile interaction
        //this.profileInfo.controls['isLegalSpouse'].patchValue(false); 
        this.isLegalSpouseTurnedOn = false;
        this.profileInfo.controls['isLegalSpouse'].patchValue((this.isLegalSpouseTurnedOn) ? 1 : 0);
        this.profileInfo.controls['runReportWithSpouse'].patchValue(false);            
      }
    });  
  }
}

// checkMarriageDate(birthday) {
//   birthday = new Date(birthday);
//   let marriedDate = new Date(this.spouseProfileInfo.value.dateOfMarriage);
//   var differ = Number(marriedDate.getFullYear() - birthday.getFullYear());
//   if (differ > 17) {
//     return true
//   } else {
//     return false;
//   }

// }
onDateChange() {
  if (this.spouseProfileInfo.value.dob && this.profileInfo.value.dob) {
    let spouseDOB = new Date(this.spouseProfileInfo.value.dob);
    spouseDOB.setFullYear(spouseDOB.getFullYear() + 18);
    let clientDOB = new Date(this.profileInfo.value.dob);
    clientDOB.setFullYear(clientDOB.getFullYear() + 18);
    this.minMarriedDate = spouseDOB > clientDOB ? spouseDOB : clientDOB;
    console.log('this.minMarriedDate', this.minMarriedDate);
    this.clientAge = this.calculateAge(this.profileInfo.value.dob);
    this.spouseAge = this.calculateAge(this.spouseProfileInfo.value.dob);
  } else {
    this.clientAge = 0;
    this.spouseAge = 0;
  }
}


}
